module.exports = new __parcel__URL__("issue-table-app-skeleton.tpl.d0dd4bec.svg").toString();